// @flow
import Journal from './Journal';

export default Journal;
